<template>
  <div class="d-flex align-baseline">
    <span
      class="upload-count-label primary--text font-weight-bold mr-6"
      data-testid="monthly-upload-label"
    >{{ $t('label') }}</span>
    <span class="d-inline-flex align-baseline mr-3">
      <span class="mr-2">{{ $t('flying_label') }}</span>
      <span
        data-testid="flying-traps-count"
        class="upload-count-number font-weight-bold"
        :class="flyingCountColor"
      >{{ sTypeUsage.traps_used }}</span>
      <span
        data-testid="flying-separator"
        class="upload-count-denominator primary--text font-weight-bold mx-1"
      >/</span>
      <span
        data-testid="flying-denominator"
        class="upload-count-denominator primary--text font-weight-bold"
      >{{ flyingDenominator }}</span>
    </span>
    <span
      v-if="featureIsActive('s_type_crawling_pests')"
      class="d-inline-flex align-baseline mr-2"
    >
      <span class="mr-2">{{ $t('crawling_label') }}</span>
      <span
        data-testid="crawling-traps-count"
        class="upload-count-number font-weight-bold primary--text"
      >{{ sTypeUsage.crawling_traps_used }}</span>
      <span
        data-testid="crawling-separator"
        class="upload-count-denominator primary--text font-weight-bold mx-1"
      >/</span>
      <span
        data-testid="crawling-denominator"
        class="upload-count-denominator primary--text font-weight-bold"
      >{{ crawlingDenominator }}</span>
    </span>
    <v-tooltip min-width="10" bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          data-testid="plan-status-help-icon"
          v-bind="attrs"
          v-on="on"
          color="grey"
        >
          fa-question-circle-o
        </v-icon>
      </template>
      <span class="tooltip-content" v-html="tooltipExplanation" />
    </v-tooltip>
  </div>
</template>

<i18n lang="yaml">
ja:
  label: '月間アップロード枚数'
  flying_label: 'ライト'
  crawling_label: '床置き'
  included_units_denominator: '{0}枚'
  unlimited_denominator: '∞'
  none_denominator: '-'
  explanation: 'アップロード枚数：<br>1回のアップロードに付き下記の通り計算<br>2画像以下＝1枚、3画像以上＝2枚'
  explanation_with_crawling: "<div>アップロード枚数：</div><div>1回のアップロードに付き下記の通り計算</div>\
    <div>【ライト】2画像以下＝1枚、3画像以上＝2枚</div><div>【床置き】1画像＝1枚</div>"

en:
  label: 'Monthly upload count'
  flying_label: 'Flying'
  crawling_label: 'Crawling'
  included_units_denominator: '{0} traps'
  unlimited_denominator: '∞'
  none_denominator: '-'
  explanation: 'Calculations per upload:<br>2 or fewer shots = 1 trap, 3 or more shots = 2 traps'
  explanation_with_crawling: "<div>Calculations per upload:</div>\
    <div>[Flying] 2 or fewer shots = 1 trap, 3 or more shots = 2 traps</div>\
    <div>[Crawling] 1 image = 1 trap</div>"
</i18n>

<script>
import { getPlanIncludedUnits, getPlanType } from '@/mixins/planOptions';
import Features from '@/mixins/features';
import { formatUploadDenominator } from './formatUploadDenominator';

export default {
  name: 'station-plan-status',
  mixins: [
    Features,
  ],
  components: {},
  computed: {
    flyingCountColor() {
      return this.sTypeUsage.included_units_are_exceeded ?
        'red--text' :
        'primary--text';
    },
    flyingDenominator() {
      const { key, params } = formatUploadDenominator({
        planType: getPlanType(this.sTypeUsage.plan),
        includedUnits: getPlanIncludedUnits(this.sTypeUsage.plan),
      });
      return this.$t(key, params);
    },
    crawlingDenominator() {
      return this.$t('none_denominator');
    },
    sTypeUsage() {
      const user = this.$store.getters.getCurrentUser;
      return user.s_type_usage;
    },
    tooltipExplanation() {
      return this.featureIsActive('s_type_crawling_pests') ?
        this.$t('explanation_with_crawling') :
        this.$t('explanation');
    },
  },
};
</script>

<style scoped lang="sass">
.upload-count-label,
.upload-count-denominator
  font-size: 14px !important

.upload-count-number
  font-size: 20px !important

.tooltip-content
  white-space: nowrap
</style>
